import React, {useEffect, useMemo} from 'react';
import {useForm} from '@inertiajs/react';
import toast from 'react-hot-toast';
import {Trans, useTranslation} from 'react-i18next';

function AuthForm({event, isAfter}) {
    const {t} = useTranslation();
    const {data, setData, post, processing, errors} = useForm({
        email: '',
        code: '',
    })

    useEffect(() => {
        if (errors.verify) {
            toast.error(errors.verify);
        }
    }, [errors]);

    function submit(e) {
        e.preventDefault()
        if (data.code) {
            post(`/camera/events/${event.id}/verify`)
        } else {
            post(`/camera/events/${event.id}/notify`)
        }
    }

    const invalid = useMemo(() => {
        if (!data.email) {
            return true;
        }

        return !data.email.includes('@') || !data.email.includes('.')
    }, [data.email]);
    const reveal = event.reveal_at_formatted;
    return (
        <div>
            {!errors.verify && !errors.code ? (
                <div>
                    <h2 className="font-bold text-xl text-white-foreground">{t('Receive album link')}</h2>
                    {isAfter ? <div>
                        <p className="text-sm text-white-foreground/70">
                            <Trans i18nKey="enterMailReveal">
                                Enter your email address to receive a link to the album once it reveals on <span
                                className="font-semibold text-white-foreground">{{reveal}}</span>.
                            </Trans>
                        </p>
                        <small
                            className="text-red-500">{t("Otherwise we won't be able to send you a link to the album once it reveals!")}</small>
                    </div> : <div>
                        <p className="text-sm text-white-foreground/70">
                            {t("Enter your email address to receive a link to the album so you can easily access it in the future.")}
                        </p>
                    </div>}

                    <form onSubmit={submit}>
                        <div className="flex flex-col mt-2">
                            <label className="font-bold text-white-foreground" htmlFor="code">{t('Email Address')}</label>
                            <input
                                value={data.email}
                                onChange={e => setData('email', e.target.value)}
                                className="rounded-[10px]"
                                type="email"
                                autoComplete={"email"}
                                required
                                placeholder={t('Email Address')} />
                            {!!errors.email && <span className="text-xs text-red-500">{errors.email}</span>}
                            <button
                                type="submit"
                                disabled={processing || invalid}
                                className=" mt-[10px] primary-camera-button">
                                {t('Notify me')}
                            </button>
                        </div>
                    </form>
                </div>
            ) : (
                <div>
                    <h2 className="font-bold text-xl text-white-foreground">{t('Looks like you already have an account')}</h2>
                    <p className="text-sm text-white-foreground/70">{t('We have just emailed you a verification code. Please enter it down below.')}</p>
                    <form onSubmit={submit}>
                        <div className="flex flex-col mt-2">
                            <label className="font-bold text-white-foreground" htmlFor="code">{t('Verification code')}</label>
                            <input
                                required
                                autoFocus={true}
                                id="code"
                                placeholder={'XXXXXX'}
                                className="rounded-[10px]"
                                type="number"
                                autoComplete="one-time-code"
                                value={data.code}
                                onChange={e => setData('code', e.target.value)}
                            />
                            <div>
                                {errors.code && <small className="text-xs text-red-500">{errors.code}</small>}
                            </div>
                            <small className="text-white-foreground/70">{t('We have to verify your email to continue.')}</small>

                            <button
                                type="submit"
                                disabled={processing}
                                className=" mt-[10px] primary-camera-button">
                                {t('Verify code')}
                            </button>
                        </div>
                    </form>
                </div>
            )}

        </div>
    );
}

export default AuthForm;
